import { useOrganizationStore } from '@/store/organization.store'

import { AccountType } from '@scrambl/shared'

interface UseAccountTypeResult {
  /**
   * The current organization's account type. Defaults to ORGANIZATION when the
   * org hasn't loaded yet so every gated surface fails safe toward the full
   * (business) experience rather than briefly hiding modules.
   */
  accountType: AccountType
  /** Convenience flag — true only for PERSONAL accounts. */
  isPersonal: boolean
}

/**
 * Single gate for account-type–conditional UI. Reads the current organization
 * from the org store (the same source AppSidebar / useFeatureFlags use) and
 * returns its account type. This is the one hook every personal-vs-organization
 * branch should consume so the default-safe behaviour lives in one place.
 */
export function useAccountType(): UseAccountTypeResult {
  const currentOrganization = useOrganizationStore(
    state => state.currentOrganization,
  )
  const accountType =
    (currentOrganization?.accountType as AccountType | undefined) ??
    AccountType.ORGANIZATION

  return {
    accountType,
    isPersonal: accountType === AccountType.PERSONAL,
  }
}
